module.exports = __webpack_public_path__ + "static/media/images_and_videos.fcd61868.svg";